import { handleWarning } from '../error-reporting';

export async function watchSubmitTimeout<T>(callback: () => Promise<T>, timeout = 60000): Promise<T> {
  const timeoutId = setTimeout(() => {
    handleWarning(new Error('ABW: Submit took more than limit time'));
  }, timeout);

  try {
    return await callback();
  } finally {
    clearTimeout(timeoutId);
  }
}
